import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useCheck_paymentMutation } from "../../../Store/Slices/rtk";
import { clearFullCart } from "../../../Store/Slices/CartSlice/cartSlice"; 

export default function CheckPayment() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation()?.search;
  const [count, setCount] = useState(10);
  const [checkOrder, { data, isLoading, isSuccess, isError }] =
    useCheck_paymentMutation();

  useEffect(() => {
    const t_code = location.split("=")[1];
    if (t_code) checkOrder(t_code);
  }, [location, checkOrder]);

  useEffect(() => {
    if (!isLoading && count > 0) {
      const timer = setTimeout(() => setCount((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    }
    if (count === 0) {
      dispatch(clearFullCart());
      navigate("/");
    }
  }, [count, isLoading]);

  return (
    <Stack
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: `linear-gradient(135deg, ${theme.palette.background.cream}, ${theme.palette.background.lightBlue})`,
        px: "2rem",
      }}
    >
      <Stack
        component={motion.div}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        sx={{
          bgcolor: theme.palette.background.paper,
          boxShadow: "0 0 30px rgba(0,0,0,0.1)",
          borderRadius: "1rem",
          p: { xs: "2rem", md: "3rem" },
          width: "100%",
          maxWidth: "500px",
          textAlign: "center",
          gap: "2rem",
        }}
      >
        {/* Loading State */}
        {isLoading && (
          <Stack alignItems="center" spacing={2}>
            <CircularProgress sx={{ color: theme.palette.primary.main }} />
            <Typography fontWeight="bold" color={theme.palette.text.secondary}>
              در حال بررسی تراکنش...
            </Typography>
          </Stack>
        )}

        {/* Success State */}
        {isSuccess && (
          <motion.div
            initial={{ opacity: 0, scale: 0.7 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ type: "spring", stiffness: 120 }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: theme.palette.success.main }}
            >
              ✅ خرید شما با موفقیت انجام شد!
            </Typography>
            <Typography>مبلغ خرید: {data?.data?.final_amount?.toLocaleString()} تومان</Typography>
            <Typography>شماره رسید: {data?.data?.sale_reference_id}</Typography>
          </motion.div>
        )}

        {/* Error State */}
        {isError && (
          <motion.div
            initial={{ opacity: 0, scale: 0.7 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ type: "spring", stiffness: 120 , }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: theme.palette.error.main }}
            >
              ❌ تراکنش ناموفق بود
            </Typography>
            <Typography sx={{ mt:".5rem"}}>
              در صورت کسر وجه، تا ۷۲ ساعت آینده به حساب شما بازمی‌گردد.
            </Typography>
          </motion.div>
        )}

        {/* Countdown + Button */}
        {!isLoading && (
          <>
            <Typography
              sx={{
                textAlign: "center",
                color: theme.palette.primary.main,
                fontWeight: 500,
              }}
            >
              در حال بازگشت به فروشگاه... ({count})
            </Typography>
            <Button
              variant="contained"
              onClick={() => {
                dispatch(clearFullCart());
                navigate("/");
              }}
              sx={{
                bgcolor: theme.palette.primary.main,
                "&:hover": { bgcolor: theme.palette.primary.low },
                // color: "white",
                fontWeight: "bold",
                borderRadius: "0.5rem",
              }}
            >
              بازگشت به فروشگاه
            </Button>
          </>
        )}
      </Stack>
    </Stack>
  );
}
